<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">
        Financial Services
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">
        Network IDTs
      </b-breadcrumb-item>
      <b-breadcrumb-item active>Add Network IDT</b-breadcrumb-item>
    </b-breadcrumb>

    <AppLoadingContainer :predicate="!isLoaded">
      <form @submit.prevent="onSubmit()">
        <div class="card">
          <div class="bg-dark card-header text-white">Add New Network IDT</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-12 form-group">
                <label for="sl">SL</label>
                <input class="form-control" v-model="networkIDT.sl" placeholder="SL" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.networkIDT.sl.$invalid && submissionAttempted">
                    {{ "SL must be 6 characters long" }}
                  </AppNotification>
                </transition>
              </div>

              <div class="col-md-4 col-sm-12 form-group">
                <label for="sa">SA</label>
                <input class="form-control" v-model="networkIDT.sa" placeholder="SA" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.networkIDT.sa.$invalid && submissionAttempted">
                    {{ "SA must be 5 characters long" }}
                  </AppNotification>
                </transition>
              </div>

              <div class="col-md-4 col-sm-12 form-group">
                <label for="famisDepartment">FAMIS Department</label>
                <input class="form-control" v-model="networkIDT.famisDepartment" placeholder="FAMIS Department" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.networkIDT.famisDepartment.$invalid && submissionAttempted">
                    {{ "Department must be 3 to 5 characters long" }}
                  </AppNotification>
                </transition>
              </div>

              <div class="col-md-4 col-sm-12 form-group">
                <label for="amountCharged">Amount Charged</label>
                <input type="number" class="form-control" min="0.01" v-model="networkIDT.amountCharged" placeholder="Amount Charged" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.networkIDT.amountCharged.$invalid && submissionAttempted">
                    {{ "Amount Charged must be left blank or given a number greater than 0" }}
                  </AppNotification>
                </transition>
              </div>
            </div>
          </div>

          <div class="card-footer d-print-none text-right">
            <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Submit</button>
            <RouterLink :to="{ name: 'NetworkIDTs' }" class="btn btn-danger">Back</RouterLink>
          </div>
        </div>
      </form>
    </AppLoadingContainer>
  </div>
</template>

<script>
import AppNotification from "@/components/shared/AppNotification";
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import NetworkIDTService from "@/services/NetworkIDTsService";
import { ToastType } from '@/services/models/shared/ToastType';

export default {
  components: {
    AppNotification
  },
  data() {
    return {
      isSubmitting: false,
      submissionAttempted: false, // Track if submit button was clicked
      networkIDT: {
        sl: null,
        sa: null,
        famisDepartment: null,
        amountCharged: null,
      },
    };
  },
  methods: {
    onSubmit() {
      const vm = this;

      // Mark the form as attempted to submit
      this.submissionAttempted = true;

      // Validate the form
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      vm.isSubmitting = true;
      NetworkIDTService.addNetworkIDT(vm.networkIDT)
        .then(() => {
          vm.alert(ToastType.Success, `The Network IDT for account ${vm.networkIDT.sl}-${vm.networkIDT.sa} was successfully created.`);
          vm.$router.replace({ name: 'NetworkIDTs' });
        })
        .catch((error) => {
          vm.alert(ToastType.Danger, error.response.statusText);
        })
        .finally(() => {
          vm.isSubmitting = false;
        });
    },
  },
  validations: {
    networkIDT: {
      sl: { required, minLength: minLength(6), maxLength: maxLength(6) },
      sa: { required, minLength: minLength(5), maxLength: maxLength(5) },
      famisDepartment: { required, minLength: minLength(3), maxLength: maxLength(5) },
      amountCharged: { 
        validAmount(value) { 
          return value === null || value > 0; 
        },
      },
    },
  },
};
</script>
